export default function (state) {
  let form = state;
  let data = {};

  if (form.dates) switch (form.dateType) {
    case 1:
      if (form.dates[0]) data.IssueDateFrom = {Serialized: form.dates[0]};
      if (form.dates[1]) data.IssueDateTo = {Serialized: form.dates[1]};
      break;
    case 2:
      if (form.dates[0]) data.StartDateFrom = {Serialized: form.dates[0]};
      if (form.dates[1]) data.StartDateTo = {Serialized: form.dates[1]};
      break;
    case 3:
      if (form.dates[0]) data.EndDateFrom = {Serialized: form.dates[0]};
      if (form.dates[1]) data.EndDateTo = {Serialized: form.dates[1]};
      break;
    case 4:
      if (form.dates[0]) data.CreateDateFrom = {Serialized: form.dates[0]};
      if (form.dates[1]) data.CreateDateTo = {Serialized: form.dates[1]};
      break;
  }
  if (form.CurrencyIds.length) data.CurrencyIds = form.CurrencyIds;

  if (form.ContragentId) {
    switch (form.ContragentSearchTypeId) {
      case 1:
        data.ClientId = form.ContragentId;
        break;
      case 2:
      case 'partner':
        data.PartnerId = form.ContragentId;
        break;
      case 'partnerLegal':
      case 3:
        data.PartnerLegalId = form.ContragentId;
        break;
    }
  }
  if (form.SumFrom) data.SumFrom = form.SumFrom;
  if (form.Number && form.Number.trim()) data.Number = form.Number.trim();
  if (form.TypeSubsidies === 1) data.ShowOnlyParent = true;
  if (form.TypeSubsidies === 2) data.ShowOnlyChild = true;
  if (form.SumTo) data.SumTo = form.SumTo;
  if (form.AvailableSumFrom) data.AvailableSumFrom = form.AvailableSumFrom;
  if (form.AvailableSumTo) data.AvailableSumTo = form.AvailableSumTo;
  if (form.IsUsed) data.IsUsed = form.IsUsed;
  if (form.IsPayed) data.IsPayed = form.IsPayed;
  if (form.Type) data.Type = form.Type;
  if (form.OwnerUserId) data.OwnerUserId = form.OwnerUserId;
  if (form.OwnerUserCode) data.OwnerUserCode = form.OwnerUserCode;
  if (form.OwnerLegalEntityId) data.OwnerLegalEntityId = form.OwnerLegalEntityId;
  data.GetSubsidies = true;
  return data;
}
